import { DBBaseComponent } from "../common/db-base/db.base.component";
import {BaseComponent} from "../common/base/base.component";
import {globalPropertyChangeHandler} from "./property-change-handler";
import { get, isFunction } from 'lodash-es';


// proxy handler for the components

export const proxyHandler = {
  set: (target: BaseComponent, key: string, value: any): boolean => {
    globalPropertyChangeHandler(target, key, value);
    return true;
  },
  get: (target: BaseComponent, key: string): any => {
    const v = get(target, key);
    if (isFunction(v)) { // bind the proper context for the methods
      // @ts-ignore
      return v.bind(target);
    }
    return v;
  }
};

const $RAF = window.requestAnimationFrame;
const $RAFQueue: Array<Function> = [];

const invokeLater = (fn: Function) => {
  if (!$RAFQueue.length) {
    $RAF(() => {
      $RAFQueue.forEach(f => f());
      $RAFQueue.length = 0;
    });
  }
  $RAFQueue.push(fn);
};


export class WidgetProxyProvider {
  public static create(instance: BaseComponent | DBBaseComponent, widgetSubType: string, propsByWidgetSubType: { [key: string]: any } | undefined) {
    // If the native Proxy is supported
    if ((window as any).Proxy) {
      return new Proxy(instance, proxyHandler);
    } else {
      // If the native Proxy is not supported, IE11
      // IE 11 support is removed in latest angular
      return
    }
  }
}
